/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LlmGrantRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  grantPermissionRequest: components.GrantPermissionRequest;
};

/** @internal */
export const LlmGrantRequest$inboundSchema: z.ZodType<
  LlmGrantRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  GrantPermissionRequest: components.GrantPermissionRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "GrantPermissionRequest": "grantPermissionRequest",
  });
});
/** @internal */
export type LlmGrantRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  GrantPermissionRequest: components.GrantPermissionRequest$Outbound;
};

/** @internal */
export const LlmGrantRequest$outboundSchema: z.ZodType<
  LlmGrantRequest$Outbound,
  z.ZodTypeDef,
  LlmGrantRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  grantPermissionRequest: components.GrantPermissionRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    grantPermissionRequest: "GrantPermissionRequest",
  });
});

export function llmGrantRequestToJSON(
  llmGrantRequest: LlmGrantRequest,
): string {
  return JSON.stringify(LlmGrantRequest$outboundSchema.parse(llmGrantRequest));
}
export function llmGrantRequestFromJSON(
  jsonString: string,
): SafeParseResult<LlmGrantRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LlmGrantRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LlmGrantRequest' from JSON`,
  );
}
